<template>
  <b-modal
    :visible="visible"
    hide-footer
    button-size="sm"
    size="lg"
    modal-cancel="false"
    no-close-on-backdrop
    @close="close"
    id="grade-add"
  >
    <template v-slot:modal-title>Crear nota de estudiante</template>
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <form @submit.prevent="save">
        <div class="container-fluid">
          <div class="row">
            <div class="col">
              <div v-if="loadedData && student.id !== null">
                Estudiante:
                <b
                  >{{ student.person ? student.person.last_name : "" }}
                  {{ student.person ? student.person.first_name : "" }}</b
                >
              </div>
              <h4 class="text-center" v-else>Cargando ...</h4>
            </div>
          </div>
          <section v-if="registration.id !== null">
            <div class="row">
              <div class="col-8">
                Curso: <b>{{ registration.course_name }}</b> &nbsp;&nbsp;&nbsp;
                Paralelo:
                <b>{{
                  registration.courses_offered_parallel == "NONE"
                    ? "Ninguno"
                    : registration.courses_offered_parallel
                }}</b>
              </div>
              <div class="col-4">
                Gestión:
                <b>{{ registration.courses_offered_year }}</b>
                &nbsp;&nbsp;&nbsp; Periodo:
                <b>{{ registration.courses_offered_period | period }}</b>
              </div>
            </div>

            <div class="row">
              <div class="col">
                Profesor:
                <b>{{ registration.teacher_fullname }}</b>
              </div>
            </div>
          </section>
          <div class="row">
            <div class="col-4 col-xl">
              <div class="form-group required">
                <ValidationProvider
                  name="absence"
                  rules="required|min_value:0"
                  v-slot="{ valid, errors }"
                >
                  <label class="control-label" for="absence">Nº Abs</label>
                  <input
                    type="number"
                    v-model="grade.absence"
                    class="form-control form-control-sm"
                    id="absence"
                  />
                  <b-form-invalid-feedback :state="valid">{{
                    errors[0]
                  }}</b-form-invalid-feedback>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-4 col-xl">
              <div class="form-group required">
                <ValidationProvider
                  name="permission"
                  rules="required|min_value:0"
                  v-slot="{ valid, errors }"
                >
                  <label class="control-label" for="permission">Nº Prm</label>
                  <input
                    type="number"
                    v-model="grade.permission"
                    class="form-control form-control-sm"
                    id="permission"
                  />
                  <b-form-invalid-feedback :state="valid">{{
                    errors[0]
                  }}</b-form-invalid-feedback>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-4 col-xl">
              <div class="form-group required">
                <ValidationProvider
                  name="attendence"
                  rules="required|min_value:0|max_value:5"
                  v-slot="{ valid, errors }"
                >
                  <label class="control-label" for="attendence">Att.</label>
                  <input
                    type="number"
                    v-model="grade.attendence"
                    class="form-control form-control-sm"
                    id="attendence"
                    step="any"
                  />
                  <b-form-invalid-feedback :state="valid">{{
                    errors[0]
                  }}</b-form-invalid-feedback>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-4 col-xl">
              <div class="form-group required">
                <ValidationProvider
                  name="works"
                  rules="required|min_value:0|max_value:10"
                  v-slot="{ valid, errors }"
                >
                  <label class="control-label" for="works">Works</label>
                  <input
                    type="number"
                    v-model="grade.works"
                    class="form-control form-control-sm"
                    id="works"
                    step="any"
                  />
                  <b-form-invalid-feedback :state="valid">{{
                    errors[0]
                  }}</b-form-invalid-feedback>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-4 col-xl">
              <div class="form-group required">
                <ValidationProvider
                  name="class_participation"
                  rules="required|min_value:0|max_value:35"
                  v-slot="{ valid, errors }"
                >
                  <label class="control-label" for="class_participation"
                    >CP</label
                  >
                  <input
                    type="number"
                    v-model="grade.class_participation"
                    class="form-control form-control-sm"
                    id="class_participation"
                    step="any"
                  />
                  <b-form-invalid-feedback :state="valid">{{
                    errors[0]
                  }}</b-form-invalid-feedback>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-4 col-xl">
              <div class="form-group required">
                <ValidationProvider
                  name="quizes"
                  rules="required|min_value:0|max_value:30"
                  v-slot="{ valid, errors }"
                >
                  <label class="control-label" for="quizes">Qs</label>
                  <input
                    type="number"
                    v-model="grade.quizes"
                    class="form-control form-control-sm"
                    id="quizes"
                    step="any"
                  />
                  <b-form-invalid-feedback :state="valid">{{
                    errors[0]
                  }}</b-form-invalid-feedback>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-4 col-xl">
              <div class="form-group required">
                <ValidationProvider
                  name="final_test"
                  rules="required|min_value:0|max_value:20"
                  v-slot="{ valid, errors }"
                >
                  <label class="control-label" for="final_test">FT</label>
                  <input
                    type="number"
                    v-model="grade.final_test"
                    class="form-control form-control-sm"
                    id="final_test"
                    step="any"
                  />
                  <b-form-invalid-feedback :state="valid">{{
                    errors[0]
                  }}</b-form-invalid-feedback>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-4 col-xl">
              <div class="form-group required">
                <ValidationProvider
                  name="final_grade"
                  rules="required|min_value:0|max_value:100"
                  v-slot="{ valid, errors }"
                >
                  <label class="control-label" for="final_grade">FG</label>
                  <input
                    type="number"
                    v-model="grade.final_grade"
                    class="form-control form-control-sm"
                    id="final_grade"
                    step="any"
                  />
                  <b-form-invalid-feedback :state="valid">{{
                    errors[0]
                  }}</b-form-invalid-feedback>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group required">
                <ValidationProvider
                  name="comments"
                  rules=""
                  v-slot="{ valid, errors }"
                >
                  <label class="control-label" for="comments">Comments</label>
                  <b-form-textarea
                    id="comments"
                    v-model="grade.comments"
                    class="form-control form-control-sm"
                    rows="2"
                    max-rows="3"
                  ></b-form-textarea>
                  <b-form-invalid-feedback :state="valid">{{
                    errors[0]
                  }}</b-form-invalid-feedback>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </div>
        <b-button type="button" size="sm" variant="danger" @click="close">
          <CIcon size="sm" name="cil-x-circle" /> Cancelar
        </b-button>
        <button
          type="submit"
          class="btn btn-success btn-sm float-right"
          variant="success"
          :disabled="invalid || loaderAdd"
        >
          <span v-if="!loaderAdd">
            <CIcon size="sm" name="cil-save" /> Guardar</span
          >
          <span v-if="loaderAdd">
            Cargando
            <CSpinner color="success" size="sm" />
          </span>
        </button>
      </form>
    </ValidationObserver>
  </b-modal>
</template>
<script>
import {
  BFormInvalidFeedback,
  BModal,
  BButton,
  BFormTextarea,
} from "bootstrap-vue";
import { Utils } from "@/plugins/utils";
import { extend } from "vee-validate";
import {
  required,
  numeric,
  min_value,
  max_value,
} from "vee-validate/dist/rules";
// services
import Students from "@/plugins/services/students";
import Grades from "@/plugins/services/grades";
import Registrations from "@/plugins/services/registrations";

export default {
  name: "GradeAddModal",
  components: { BFormInvalidFeedback, BModal, BButton, BFormTextarea },
  props: {
    modShowAddGrade: { type: Boolean, required: true },
    id_student: { type: Number, required: true },
    registration_id: { type: Number, required: true },
    course_offered_id: { type: Number, required: true },
  },
  data() {
    return {
      student: {
        id: null,
      },
      grade: {
        absence: 0,
        permission: 0,
        attendence: 0,
        works: 0,
        class_participation: 0,
        quizes: 0,
        final_test: 0,
        final_grade: 0,
        registration_id: 0,
      },
      registration: {
        id: null,
      },
      loadedData: false,
      loaderAdd: false,
      dataEmit: { modalShow: false, data: null, status: 200 },
    };
  },
  mounted() {
    this.loadedData = false;
    this.loaderAdd = false;
    this.getData();
    this.getDataRegistration();
  },
  created() {
    extend("required", {
      ...required,
      message: "Este campo es requerido",
    });
    extend("numeric", {
      ...numeric,
      message: "Este campo debe contener números.",
    });

    extend("min_value", {
      ...min_value,
      message: "Por favor, escribe un valor mayor o igual a {min}.",
    });

    extend("max_value", {
      ...max_value,
      message: "Por favor, escribe un valor menor o igual a {max}.",
    });
  },
  computed: {
    visible() {
      return this.modShowAddGrade;
    },
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  watch: {
    "grade.attendence"(attendence) {
      if (parseFloat(attendence) >= 0) {
        this.sumFinalGrade();
      }
    },
    "grade.works"(works) {
      if (parseFloat(works) >= 0) {
        this.sumFinalGrade();
      }
    },
    "grade.class_participation"(class_participation) {
      if (parseFloat(class_participation) >= 0) {
        this.sumFinalGrade();
      }
    },
    "grade.quizes"(quizes) {
      if (parseFloat(quizes) >= 0) {
        this.sumFinalGrade();
      }
    },
    "grade.final_test"(final_test) {
      if (parseFloat(final_test) >= 0) {
        this.sumFinalGrade();
      }
    },
  },
  methods: {
    getData() {
      Students.getOne(this.id_student)
        .then((res) => {
          this.student = res.data;
          this.loadedData = true;
        })
        .catch((err) => {
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Estudiante no encontrado.");
            this.closeModal(null, 404);
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.closeModal(null, 500);
          }
          this.loadedData = true;
        });
    },
    getDataRegistration() {
      Registrations.showView(this.registration_id)
        .then((res) => {
          this.registration = res.data;
        })
        .catch((err) => {
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Programación no encontrada.");
            this.closeModal(null, 404);
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.closeModal(null, 500);
          }
        });
    },
    save() {
      this.loaderAdd = true;
      this.grade.course_offered_id = this.course_offered_id;
      this.grade.student_id = this.id_student;
      this.grade.registration_id = this.registration_id;
      this.grade.created_by = this.userAuth.username;
      Grades.add(this.grade)
        .then((res) => {
          this.loaderAdd = false;
          if (res.data.data!="error") {
            Utils.setFlash("success", res.data.message);
            this.closeModal(res.data.data);
          } else {
            Utils.setFlash("danger", res.data.message);
            this.closeModal();
          }
        })
        .catch((err) => {
          this.loaderAdd = false;
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", err.response.data.data);
            this.closeModal(null, 404);
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.closeModal(null, 500);
          }
        });
    },
    closeModal(data = null, status = 200) {
      this.student = {
        id: null,
      };
      this.dataEmit.modalShow = false;
      this.dataEmit.data = data;
      this.dataEmit.status = status;
      this.$emit("gradeAddModal", this.dataEmit);
    },
    sumFinalGrade() {
      this.grade.final_grade =
        Math.round(
          (parseFloat(this.grade.attendence) +
            parseFloat(this.grade.works) +
            parseFloat(this.grade.class_participation) +
            parseFloat(this.grade.quizes) +
            parseFloat(this.grade.final_test)) *
            10
        ) / 10;
    },
    close() {
      this.closeModal();
    },
  },
};
</script>
